/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { styledBarStyles } from './styles';
export var StyledBar = function StyledBar(props) {
  var progress = props.progress,
    breakpoint = props.breakpoint,
    positionBottom = props.positionBottom,
    showOnTop = props.showOnTop;
  return jsx("div", {
    id: "styledBar",
    role: "progressbar",
    "aria-valuenow": progress
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: styledBarStyles({
      progress: progress,
      breakpoint: breakpoint,
      positionBottom: positionBottom,
      showOnTop: showOnTop
    })
  });
};